import React from 'react';
import ServiceCloud from '../../../components/service/ServiceCloud';
import QuoteForm from '../../../components/home/QuoteForm';
import ServicesSection from '../../../components/home/ServicesSection';
import DiscussionSection from '../../../components/home/DiscussionSection';
import ServiceTrusted from '../../../components/service/ServiceTrusted';
import ServiceExperienced from '../../../components/service/ServiceExperienced';
import ServiceWorkflow from '../../../components/service/ServiceWorkflow';
import CompareQualitySection from '../../../components/home/CompareQualitySection';
import ProjectsSection from '../../../components/home/ProjectsSection';
import TestimonialsSection from '../../../components/home/TestimonialsSection';
import ModelsSection from '../../../components/home/ModelsSection';
import ServiceHiring from '../../../components/service/ServiceHiring';
import BestArchitectureSection from '../../../components/home/BestArchitectureSection';
import DesireTechSection from '../../../components/home/DesireTechSection';
import ServiceChoose from '../../../components/service/ServiceChoose';
import SoftwaresSection from '../../../components/home/SoftwaresSection';
import AwardsSection from '../../../components/home/AwardsSection';
import FAQSection from '../../../components/home/FAQSection';
import BlogsSection from '../../../components/home/BlogsSection';
import ContactSection from '../../../components/home/ContactSection';

// Industry Images
import residentialImg from '../../../assets/img/BestArchitecture/Residential.png';
import commercialImg from '../../../assets/img/BestArchitecture/Commercial.png';
import urbanImg from '../../../assets/img/BestArchitecture/Urban.png';
import industrialImg from '../../../assets/img/BestArchitecture/Industrial Sector.png';
import interiorImg from '../../../assets/img/BestArchitecture/Interior Design.png';
import institutionalImg from '../../../assets/img/BestArchitecture/Institutional Projects.png';

const PointCloudBimPage = () => {
  const workflowSteps = [
    {
      step: "Step 1",
      title: "Data Collection & Review",
      desc: "We collect your point cloud scans and evaluate the project requirements."
    },
    {
      step: "Step 2",
      title: "Data Processing",
      desc: "We clean, register, and segment point cloud data in preparation for modelling."
    },
    {
      step: "Step 3",
      title: "BIM Conversion",
      desc: "We convert point cloud data into intelligent BIM models that consist of structural, architectural and MEP components."
    },
    {
      step: "Step 4",
      title: "Quality Check & Validation",
      desc: "We ensure the models are accurate, complete and comply with all project needs."
    },
    {
      step: "Step 5",
      title: "Delivery & Support",
      desc: "We deliver the BIM files in a format that can be incorporated into your workflow, as well as provide support for any revisions or additional integration."
    }
  ];

  const customIndustries = [
    {
      title: "Residential and Commercial Buildings",
      desc: "Scan to BIM for homes and apartments.",
      backContent: "Accurate as-built models for renovation and expansion of villas and multi-family homes using precise point cloud registration.",
      img: residentialImg
    },
    {
      title: "Commercial",
      desc: "High-precision modeling for retail and offices.",
      backContent: "Accurate laser scanning to BIM for high-rise offices, hotels, and retail malls, ensuring clash-free design coordination.",
      img: commercialImg
    },
    {
      title: "Institutional Projects",
      desc: "Specialized BIM for public spaces.",
      backContent: "Detailed scan-to-BIM for schools, hospitals, and government facilities to satisfy USA building standards.",
      img: institutionalImg
    },
    {
      title: "Industrial Sector",
      desc: "Modeling for complex manufacturing plants.",
      backContent: "Heavy-duty BIM for factories and warehouses with precise MEP coordination from 3D laser scan data.",
      img: industrialImg
    },
    {
      title: "Urban",
      desc: "Master planning from scan data.",
      backContent: "Large-scale city modeling and infrastructure visualization using high-density LiDAR point cloud data.",
      img: urbanImg
    },
    {
      title: "Interior Design",
      desc: "High-precision interior detailing.",
      backContent: "Scan data conversion for internal spatial optimization, visualizing fit-outs and architectural finishes with millimeter accuracy.",
      img: interiorImg
    }
  ];

  const choosePoints = [
    {
      title: "Accuracy That Matters",
      desc: "Every measurement in your BIM model has been verified twice before creating the final, accurate BIM model."
    },
    {
      title: "Fast Project Turnaround",
      desc: "We work fast without sacrificing quality so that you can hit your deadlines."
    },
    {
      title: "Cost Savings",
      desc: "Reduce the amount of time wasted on the project day by eliminating on-site errors, reducing the amount of material wasted, and eliminating unneeded labor costs."
    },
    {
      title: "Seamless Integration",
      desc: "All models created are compatible with all major BIM and CAD software platforms."
    },
    {
      title: "Expert Team",
      desc: "All of our architects and modelers have extensive experience converting complex scanned files into usable Building Information Models."
    },
    {
      title: "Nationwide Service",
      desc: "We provide services to contractors, engineers, and design firms throughout the United States."
    },
    // {
    //   title: "Cost-Effective",
    //   desc: "Outsourcing to us helps you reduce overhead costs while maintaining international quality standards and precision."
    // },
    // {
    //   title: "Vetted Team",
    //   desc: "Our modelers are certified experts with over 10 years of experience in Point Cloud to BIM conversion and analysis."
    // }
  ];

  const pointCloudFaqs = [
    {
      question: "What is the difference between Point Cloud and BIM?",
      answer: "The point cloud is the recreation of the physical world as a set of three-dimensional points, captured by a laser scanner, while the Building Information Model (BIM) is a digital representation of a building, containing information about the digital model itself so that you can create a schedule during planning, a design during construction, and manage the building after construction."
    },
    {
      question: "Why should I choose a professional Point Cloud to BIM service?",
      answer: "Professional service providers provide accurate data; reduce human error; produce models that work with your workflow; and save you time and money by reducing the overall time spent on your project by a significant amount."
    },
    {
      question: "Which software do you support for BIM models?",
      answer: "We can provide completed models in Revit, AutoCAD, Navisworks, ArchiCAD, and other recognized forms of BIM."
    },
    {
      question: "How long does it take to convert point cloud data into BIM?",
      answer: "Typically, converting a point cloud to BIM takes between one and four weeks, depending on the size and complexity of the point cloud, although we are able to complete the project with a high level of precision."
    }
  ];

  return (
    <div className="point-cloud-bim-page">
      <ServiceCloud
        overline="Point Cloud to BIM Service USA"
        subtitle="Transform your laser scan data into highly accurate BIM models with our expert Point cloud to BIM services. We help architects, contractors, and engineering firms across the USA convert point cloud data into intelligent 3D Revit models — faster, cost-effective, and with precision."
        buttonText="Hire react developers now"
      />
      <QuoteForm customStyle={{ marginTop: '0px' }} />
      <ServiceTrusted
        title={<><span className="text-primary">Point Cloud</span> to BIM Company USA</>}
        paragraphs={[
          "We are one of the Top USA based Point cloud to BIM services companies and 10+ Years Experience. We offer the best quality of Point Cloud to BIM Service. Our architect team, BIM modelers, designers and drafters are skilled on the use of the latest bim software to provide high quality models that can satisfy the USA international building standards and codes.",
          "Our Point Cloud to BIM Services assist the contractors, stakeholders and AEC professionals to analyze the current conditions in order to make important decisions related to renovation and demolition projects. Our scanned images, drawings, and plans are converted into information-rich 3D models in residential, commercial, industrial, infrastructure, and heritage projects.",
          "Our as-built models that are based on scanned data include all architectural, structural, and MEP data, with the necessary amount of detail (LOD 100-500). Having an experience of more than 10 years, we have already fulfilled over 8,000 projects in the USA, UK, Canada, Australia, Europe and other countries."
        ]}
        buttonText="Book a Meeting"
      />
      <ServicesSection />
      <DiscussionSection
        title={<><span className="text-primary">Start Your Point</span> Cloud to BIM & Point Cloud to CAD Project Today</>}
        subtitle="As a company that has been vetted by industry leaders, we provide high-quality, fast, and reliable 3D scanning services to convert 3D scanned images into LOD-compliant construction-ready BIM/CAD models."
        buttonText="Book a Free Consultation"
      />
      <ServiceExperienced
        title={<><span style={{ color: '#54b248' }}>Experience Point Cloud to</span> BIM Conversion with LOD 100 to 500</>}
        subtitle="Our Point to BIM Services can produce extremely accurate and scalable BIM Models from your point cloud scans and can incorporate levels of detail (LOD) between 100 (Conceptual Designs) and 500 (Detailed Construction Models). We convert your point cloud scans into actionable, informative, 3-Dimensional 3D models so that architects, engineers, and contractors can use them to minimize errors, enhance workflows, and improve the accuracy of plans for residential, commercial, industrial, and infrastructure projects throughout the United States."
      />
      <ServiceWorkflow
        title={<><span className="text-primary">Our </span> Point Cloud to BIM Process</>}
        description="We follow a structured workflow to ensure every project is completed efficiently:"
        steps={workflowSteps}
      />
      <CompareQualitySection />
      <ProjectsSection />
      <TestimonialsSection />
      <ModelsSection />
      <ServiceHiring />
      <BestArchitectureSection
        title={<><span style={{ color: '#54b248' }}>Top-tier Scan to BIM Services </span> <span style={{ color: 'white' }}>Across All Industries</span></>}
        subtitle="With experience in a wide range of industries, we provide top-notch architectural outsourcing solutions with valuable insights."
        industries={customIndustries}
      />
      <DesireTechSection
        title={<><span style={{ color: '#54b248' }}>Ready to Transform</span> Your Point Cloud Data into Actionable BIM Models?</>}
        subtitle="Let our team of expert architects, BIM modelers, and designers craft the high-quality, information-rich models your project deserves. Whether it's residential, commercial, industrial, or heritage, we guarantee precision and efficiency."
        buttonText="Contact Us Today for a Free Quote"
        subtitleStyle={{ maxWidth: '900px', margin: '18px auto 45px auto' }}
      />
      <ServiceChoose
        title={<><span style={{ color: '#54b248' }}>Benefits of Working with </span> Our Point Cloud to BIM Company</>}
        subtitle="When you collaborate with a reliable Point Cloud to BIM service provider in the USA, you will have an edge over other competitors with how efficiently, collaboratively, and accurately you execute your project."
        points={choosePoints}
      />
      <SoftwaresSection />
      <AwardsSection />
      <FAQSection faqs={pointCloudFaqs} />
      <BlogsSection />
      <ContactSection />
    </div>
  );
};

export default PointCloudBimPage;
